import React from 'react';

export const MagnifyingGlassSvg = (props) => {

  const { width, height, color } = props;

  if (color) {
    return (
      <svg width={width ?? "36"} height={height ?? "36"} viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_6933_3659)">
          <path d="M27.3879 24.6414L24.5599 27.4694L19.6099 22.5194L22.4379 19.6914L27.3879 24.6414Z" fill={color} />
          <path d="M34.6828 29.1093L28.8038 23.2303C28.0228 22.4493 26.7568 22.4493 25.9758 23.2303L23.1478 26.0583C22.3668 26.8393 22.3668 28.1053 23.1478 28.8863L29.0268 34.7653C30.5888 36.3283 33.1228 36.3283 34.6848 34.7653C36.2448 33.2043 36.2438 30.6713 34.6828 29.1093Z" fill={color} />
          <path fill-rule="evenodd" clipRule="evenodd" d="M27.0859 13.6699C27.0859 21.1258 21.0418 27.1699 13.5859 27.1699C6.13009 27.1699 0.0859375 21.1258 0.0859375 13.6699C0.0859375 6.21408 6.13009 0.169922 13.5859 0.169922C21.0418 0.169922 27.0859 6.21408 27.0859 13.6699ZM23.0859 13.6699C23.0859 18.9166 18.8326 23.1699 13.5859 23.1699C8.33923 23.1699 4.08594 18.9166 4.08594 13.6699C4.08594 8.42322 8.33923 4.16992 13.5859 4.16992C18.8326 4.16992 23.0859 8.42322 23.0859 13.6699Z" fill={color} />
        </g>
        <defs>
          <clipPath id="clip0_6933_3659">
            <rect width="36" height="36" fill="white" />
          </clipPath>
        </defs>
      </svg>
    )
  }

  return (
    <svg width={width ?? "36"} height={height ?? "36"} viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_5996_18765)">
        <path d="M27.3879 24.6414L24.5599 27.4694L19.6099 22.5194L22.4379 19.6914L27.3879 24.6414Z" fill="#9EACB0" />
        <path d="M34.6828 29.1093L28.8038 23.2303C28.0228 22.4493 26.7568 22.4493 25.9758 23.2303L23.1478 26.0583C22.3668 26.8393 22.3668 28.1053 23.1478 28.8863L29.0268 34.7653C30.5888 36.3283 33.1228 36.3283 34.6848 34.7653C36.2448 33.2043 36.2438 30.6713 34.6828 29.1093Z" fill="#566F75" />
        <path d="M13.5859 27.1699C21.0418 27.1699 27.0859 21.1258 27.0859 13.6699C27.0859 6.21408 21.0418 0.169922 13.5859 0.169922C6.13009 0.169922 0.0859375 6.21408 0.0859375 13.6699C0.0859375 21.1258 6.13009 27.1699 13.5859 27.1699Z" fill="#9EACB0" />
        <path d="M13.5859 23.1699C18.8326 23.1699 23.0859 18.9166 23.0859 13.6699C23.0859 8.42322 18.8326 4.16992 13.5859 4.16992C8.33923 4.16992 4.08594 8.42322 4.08594 13.6699C4.08594 18.9166 8.33923 23.1699 13.5859 23.1699Z" fill="#AEDDF7" />
      </g>
      <defs>
        <clipPath id="clip0_5996_18765">
          <rect width="36" height="36" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}